// views.app.reports.webSecurityHeaders

export const WEB_SECURITY_HEADERS = {
  title: 'Web Security Headers',
  description:
    'HTTP security headers are a fundamental part of website security. Implement them to protect your website against the types of attacks that your site is most likely to come across.'
};
